import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { className: "fw-bolder text-dark" }, "About You"),
  /*#__PURE__*/_createElementVNode("div", { className: "text-gray-400 fw-bold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please check out "),
    /*#__PURE__*/_createElementVNode("a", { className: "link-primary fw-bolder" }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_3 = { className: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { className: "form-label" }, "Profile URL(LinkedIn or XING)", -1)
const _hoisted_5 = { className: "fv-row mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { className: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "City")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        name: "profileUrl",
        class: "form-control form-control-lg form-control-solid"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "profileUrl",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        name: "city",
        class: "form-control form-control-lg form-control-solid"
      }),
      _createVNode(_component_ErrorMessage, {
        name: "city",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}